const pages = (state) => state.pages

export default {
  pages
}
